import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EvaluatorService } from 'src/app/core/services/evaluator.service';

@Component({
  selector: 'app-general-remarks',
  templateUrl: './general-remarks.component.html',
  styleUrls: ['./general-remarks.component.scss']
})
export class GeneralRemarksComponent implements OnInit {
  @Input() details;

  public remarksForm: FormGroup;
  displayedColumns: string[] = [
    'index',
    'date',
    'addedBy',
    'remark',
  ];
  public isLoading: boolean = false;
  public remarksData;
  public applicationId;
  public applicationDetails;
  public isSubmitting: boolean = false;
  constructor(
    private fb: FormBuilder,
    private evaluatorService: EvaluatorService
  ) { }

  ngOnInit(): void {
    this.remarksForm = this.fb.group({
      remarks: new FormControl('', [Validators.required]),
    });
    this.fetchremarks()
  }

  fetchremarks() {
    this.isLoading = true
    this.evaluatorService.getRemarks(this.details.id).subscribe(res => {
      this.remarksData = res
      this.isLoading = false
    })
  }

  addRemarks() {
    this.isLoading = true
    const body = {
      applicationId: this.details.id,
      content: this.remarksForm.value.remarks
    }
    this.evaluatorService.addRemark(body).subscribe(res => {
      this.isLoading = false
      this.fetchremarks()
    })
  }

}
